// routes/user-revival.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () => import('src/clientRoutes/user-revival')

export const handle = { name: 'user-revival' }

export default dynamic(getClientModule, { ssr: false })
